import { render, staticRenderFns } from "./DialogEditEconomicGroupClients.vue?vue&type=template&id=d9e22064"
import script from "./DialogEditEconomicGroupClients.vue?vue&type=script&lang=js"
export * from "./DialogEditEconomicGroupClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports